import { render, staticRenderFns } from "./Pro.vue?vue&type=template&id=56b12d46&scoped=true"
var script = {}
import style0 from "./Pro.vue?vue&type=style&index=0&id=56b12d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b12d46",
  null
  
)

export default component.exports